<template>
  <div>

    <HeaderBreadcrumbs
      :items="[
        { label: 'Newspapers', to: { name: NewspaperCreatePath.name } },
      ]"
      title="All Newspapers"
    />

    <div class="flex-col w-full bg-white shadow-sm rounded-lg">
      <div class=" w-full  flex items-center justify-between rounded-lg px-4 my-3 py-3">
      <div class="w-2/6 relative">
        <i class="fa-solid fa-magnifying-glass text-gray-400 text-xl absolute top-2 left-3"></i>
        <input placeholder="Search by Newspaper Name or ID"
          class="p-2.5 pl-5 mb-1 w-full text-sm border rounded-lg" type="search" v-model="query_search"
          @input="onSearch" v-on:keyup.enter="onSearch" />
        <small class="pt-3" v-if="typing"> <em> typing ... </em> </small>
      </div>
      <div class="relative w-3/4 flex justify-end">
        <button
          class="text-gray-500 mr-3 bg-blue-700 border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
          type="button">
          <router-link
                  class="text-white px-1 py-2"
                  :to="{ name: NewspaperCreatePath.name }"
                >
                  <i class="fa fa-plus"></i> Add New
                </router-link>
        </button>
        <button
        class="text-gray-500 flex justify-start items-center mr-3 bg-white border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
        >
        <span>
                   <svg class="w-6 h-6 p-0 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M11.32 6.176H5c-1.105 0-2 .949-2 2.118v10.588C3 20.052 3.895 21 5 21h11c1.105 0 2-.948 2-2.118v-7.75l-3.914 4.144A2.46 2.46 0 0 1 12.81 16l-2.681.568c-1.75.37-3.292-1.263-2.942-3.115l.536-2.839c.097-.512.335-.983.684-1.352l2.914-3.086Z" clip-rule="evenodd"/>
  <path fill-rule="evenodd" d="M19.846 4.318a2.148 2.148 0 0 0-.437-.692 2.014 2.014 0 0 0-.654-.463 1.92 1.92 0 0 0-1.544 0 2.014 2.014 0 0 0-.654.463l-.546.578 2.852 3.02.546-.579a2.14 2.14 0 0 0 .437-.692 2.244 2.244 0 0 0 0-1.635ZM17.45 8.721 14.597 5.7 9.82 10.76a.54.54 0 0 0-.137.27l-.536 2.84c-.07.37.239.696.588.622l2.682-.567a.492.492 0 0 0 .255-.145l4.778-5.06Z" clip-rule="evenodd"/>
</svg>
                </span>
        <router-link
                  class="px-1 text-gray-500"
                  :to="{ name: NewspaperEditBulky.name }"
                >
                <span>
                  Bulk Edit Printed Price
                </span>
        </router-link>
        </button>
        <button @click="toggleDropdown"
          class="text-gray-500 bg-white border focus:outline-none font-medium rounded-lg text-sm px-2 py-2.5 text-center"
          type="button"> <i class="fa-solid fa-filter"></i> Filter <i class="fa-solid fa-chevron-down"></i>
        </button>
        <FilterComponent
          :isDropdownVisible.sync="isDropdownVisible"
          @reloadPage="reloadPage"
          @input="handleFilterInput"
        />
  </div>
    </div>
    <div >
      <TableBooks class="border-b border-gray-50 " id="my-table" :books="Newspaper" :currentPage="currentPage" :perPage="perPage" :isLoading="isLoading"
      :reloadPage="reloadPage" @sort-by="handleSortBy" />
    </div>
    <div class="flex bg-white justify-between pl-5 pr-3 pt-4 mb-5 border-t border-gray-100 mt-1">
        <div class="font-semibold">
          <span class="text-gray-500 font-normal">Showing </span> {{currentPage}}-{{perPage}} <span class="text-gray-500 font-normal">of</span> {{ formatPriceBasic(totalRows) }}
        </div>
        <div class="mb-2">
          <t-pagination
          :total-items="Number(totalRows)"
          :per-page="perPage"
          v-model="currentPage"
          @change="onClickPage"
          />
        </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import TableBooks from "../../components/ebook/table.vue";
import { NewspaperCreatePath,NewspaperEditBulky } from "../../router/content";
import FilterComponent from '../../components/form/FilterComponent.vue'
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
//import { EventBus } from '../../event-bus';
import 'flowbite';
import 'flowbite/dist/flowbite.css';
import constant from "../../store/constant";
const { ROLES } = constant;
const ITEM_STATUS = Object.entries(constant.ITEM_STATUS_NEWS_AND_MAG).map(item => { return {text: item[0], value: item[1]} })
const ITEM_CONTENT_TYPE = Object.entries(constant.ITEM_CONTENT_TYPE).map((item) => {
  return { text: item[0], value: item[1] };
});

export default {
  name: "newspaper",
  components: {
    TableBooks,
    FilterComponent,
    HeaderBreadcrumbs
    // SortComponent,
    // ContentTypeSelector,

  },
  data() {
    return {
      NewspaperCreatePath,
      NewspaperEditBulky,
      query_search: null,
      status: null,
      isDropdownVisible: false,
      vendor: [],
      sortOrder:[],
      contentType:null,
      createdSort:null,
      vendorSearchOptions: [],
      isVendorSearch: false,
      statusOptions: [
        {text: '---Status [All]---', value: null},
        ...ITEM_STATUS
      ],
      contentTypeOptions: [
      { text: '---Content Type [All]---', value: null },
      ...ITEM_CONTENT_TYPE,
      ],
      currentPage: 1,
      perPage: 50,
      debounce: null,
      typing: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'Newspapers | Content Management System Ebooks Gramedia.com';
      }
    },
  },
  computed: {
    ...mapGetters('auth', { auth: 'auth' }),
    ...mapGetters("newspaper", ["Newspaper"]),
    ...mapState({
      isLoading: (state) => state.newspaper.isLoading,
      isError: (state) => state.newspaper.isError,
      totalRows: (state) => state.newspaper.totalRows,
    }),
  },
  created() {
    this.actionFirst();
  },
  methods: {
    ...mapActions('vendors', ['searchVendors']),
    ...mapActions('newspaper', ['fetchNewsPaper','searchNewsPaper']),
    actionFirst() {
      const query = this.$route.query;
      this.currentPage = query.page ?? this.currentPage;
      this.perPage = query.limit ?? this.perPage;
      this.query_search = query.q ?? this.query_search;
      this.status = query.status ?? this.status;
      if (typeof(query.vendor_id) == "string") {
        const vendor = query.vendor_id.split("#");
        this.vendor = [{id: vendor[0], name: vendor[1]}];
      } else {
        this.vendor = (query.vendor_id ?? []).map(val => {
          const vendor = val.split("#");
          return {
            id: vendor[0],
            name: vendor[1],
          }
        });
      }
      this.reloadPage();
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
    },
    setContentType(getContentType) {
      this.contentType = getContentType;
      this.reloadPage();
    },
    handleFilterInput({ contentType, status, vendor }) {
      this.contentType = contentType;
      this.status = status;
      this.vendor = vendor;
      this.reloadPage();
    },
    actionGetNewsPaper() {
      this.vendor = [];
      let payload = {
        page: this.currentPage,
        limit: this.perPage,
      };
      this.fetchNewsPaper(payload);
      this.setQuery(payload);
    },
    actionSearchNewsPaper() {
      const payload = {
        q: this.query_search ?? '',
        page: this.currentPage,
        limit: this.perPage,
        content_type:this.contentType,
        vendor_id: this.vendor.map((val) => val.id),
        sort:this.sortOrder.criteria,
        order:this.sortOrder.order,
        status: this.status,
      };
      this.searchNewsPaper(payload);
      payload.vendor_id = this.vendor.map((val) => `${val.id}#${val.name}`);
      this.setQuery(payload);
    },
    handleSortBy(criteria) {
      this.sortOrder = criteria
      this.actionSearchNewsPaper();
    },
    vendorRemove() {
      this.vendor = [];
      if (this.query_search) this.actionSearchNewsPaper();
      else this.actionGetNewsPaper();
    },
    vendorChange() {
      this.currentPage = 1;
      this.reloadPage();
    },
    vendorFind(query) {
      if (!query) return;

      this.isVendorSearch = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        let payload = {
          name: query,
          limit: 10,
        };
        this.searchVendors(payload)
          .then((response) => {
            this.vendorSearchOptions = response.data.data.rows;
            this.isVendorSearch = false;
          })
          .catch(() => {
            this.isVendorSearch = false;
          });
      }, 600);
    },
    permFilterVendor() {
      switch (this.auth.role_id) {
        case ROLES.SUPER_ADMIN:
          return true;
        case ROLES.INTERNAL_ADMIN:
          return true;
        case ROLES.INTERNAL_DATA_ENTRY:
          return true;
        default:
          return false;
      }
    },
    onSearch(event) {
      this.query_search = event.target.value;
      this.currentPage = 1;
      if (!this.query_search && !this.vendor.length) {
        this.actionGetNewsPaper();
        clearTimeout(this.debounce);
        return;
      }
      this.typing = true;
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.typing = false;
        this.actionSearchNewsPaper();
      }, 600);
    },
    onClearSearch() {
      this.query_search = null;
      this.vendor = [];
      this.contentType = null;
      this.createdSort = null;
      this.status = null;
      this.currentPage = 1;
      this.reloadPage();
    },
    onClickPage(page) {
      this.currentPage = page;
      this.reloadPage();
    },
    reloadPage() {
      if (!this.query_search && !this.status && !this.vendor.length && !this.contentType && !this.createdSort) this.actionGetNewsPaper();
      else this.actionSearchNewsPaper();
    },
    changeContentType() {
      this.reloadPage();
    },

    statusChange() {
      this.actionSearchNewsPaper();
    },
    formatPriceBasic(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatPrice(value, currency) {
      if (value) {
        var formatter = null;
        if (currency == "USD") {
          formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
          });
        } else {
          formatter = new Intl.NumberFormat("en-ID", {
            style: "currency",
            currency: currency,
          });
        }

        return formatter.format(value);
      }

      return "0";
    },
    setQuery(q = {}) {
      this.$router.push({ path: this.$route.path, state: q }).catch(() => {});
    }
  },
};
</script>

<style scoped>

</style>
